import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class GroupsInfo extends Vue {
	@Prop({ required: true }) board!: Array<any>

	get companiesGroups() {
		return new Set(
			this.board.reduce((final, entry) => {
				if (entry.isGroup) final.push(entry.company_group_name)
				return final
			}, []),
		)
	}

	getAllEntriesFromGroup(groupName) {
		return this.board.filter((entry) => {
			return entry.company_group_name === groupName
		})
	}

	getAllCompaniesCNPJFromGroup(groupName) {
		return new Set(
			this.getAllEntriesFromGroup(groupName).reduce((final, entry) => {
				if (entry.cnpj) final.push(entry.cnpj)
				return final
			}, []),
		)
	}

	getOneByCNPJ(cnpj) {
		return this.board.find((entry) => {
			return entry.cnpj === cnpj
		})
	}

	getEntriesByCNPJ(cnpj) {
		return this.board.filter((entry) => {
			return entry.cnpj === cnpj
		})
	}
}
